import Helmet from "react-helmet";
import Footer from "../../components/footer";
import "./style.scss";
import NavBar from "../../components/navbar";

const Careers = () => {
  return (
    <>
      <Helmet>
        <title>Tekstrive - Careers</title>
      </Helmet>
      <NavBar />
      <div className="contact-container">
        <Hero />
        <ContactSection />
        <Footer />
      </div>
    </>
  );
};

const Hero = () => {
  return (
    <>
      <section className="section-global bg-shade-blue hero">
        <div className="container">
          <div className="row">
            <div className="col-lg-7">
              <div className="section-tag mb-8">Careers</div>
              <h1 className="display-1">
                We are always here to ensure customer satisfaction
              </h1>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

const ContactSection = () => {
  const contactLinkData = [
    {
      title: "Workspace One Administrator",
      text: "Full Time",
      desc: "Installation and configuration for the Workspace One platform including all software components, appliances, databases, firewall configurations, and load balancing as well as Workspace One components: Workspace One Access, UEM, Tunnel, UAG, Horizon, Assist.Perform standard maintenance of the VMWare Workspace One environment including tasks such as performing upgrades, bug fixes, application troubleshooting, application validation for releases etc.Preforming annual APNs and APNs for application certificate renewal in Workspace ONE console.Manage threat and vulnerability management programs including threat and vulnerability analysis for all workspace One servers as well as all the end point devices(iOS, Android and Windows). Work under supervision.Travel and or relocation to unanticipated client sites throughout USA is required.",
      edu: "Bachelor’s degree in Computer Science/ IT/ Engineering (Any)/ or closely related field with Twelve (12) months of experience in the job offered or as an IT Consultant or Analyst or Programmer or Developer or Manager or related field.",
      exp: "Experience of Twelve (12) months working on VMWare Workspace One is required. Travel and/or relocation to unanticipated client sites required. The frequency of travel is currently not known as it depends on the client and project requirement that cannot be currently anticipated. Employer provides Information technology services to various clients in USA and hence implementing projects will require such travel.",
      loc: "TekStrive LLC 291 S Preston Road, Unit 940 Prosper, TX 75078",
      link: "mailto:Immigration@tekstrive.org",
    },
  ];
  return (
    <>
      <section className="section-global">
        <div className="container container-2">
          <div className="row gy-4">
            {contactLinkData.map((e, i) => (
              <div className="col-lg-12 col-md-12" key={i}>
                <a href={e.link} className="contact-link">
                  <div className="contact-link-container d-flex align-items-center">
                    <div className="ms-3">
                      <div className="txt-1 fw-500 color-1">{e.title}</div>
                      <div className="txt-2">{e.text}</div>
                      <br />
                      <div className="txt-highlight">Posting Date</div>
                      <div className="txt-3">April 08 2025</div>
                      <br />
                      <div className="txt-highlight">Job Duties</div>
                      <div className="txt-3">{e.desc}</div>
                      <br />
                      <div className="txt-highlight">Experience</div>
                      <div className="txt-3">{e.exp}</div>
                      <br />
                      <div className="txt-highlight">Education</div>
                      <div className="txt-3">{e.edu}</div>
                      <br />
                      <div className="txt-highlight">Location</div>
                      <div className="txt-3">{e.loc}</div>
                      <br />
                      <div className="btn btn-primary">Apply Now</div>
                    </div>
                  </div>
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Careers;
